module.exports = __webpack_public_path__ + "static/media/doctor5-300.c7625bb8.webp";